/**
 * Días de disponibilidad. Convención JS getDay(): 0=Domingo … 6=Sábado.
 */
export const DEFAULT_AVAILABILITY_DAYS: number[] = [1, 2, 3, 4, 5, 6]; // Lun-Sáb

export const resolveAvailabilityDays = (raw?: number[] | null): number[] => {
  if (!raw || raw.length === 0) return [...DEFAULT_AVAILABILITY_DAYS];
  const cleaned = [...new Set(raw)]
    .filter((d) => Number.isInteger(d) && d >= 0 && d <= 6)
    .sort((a, b) => a - b);
  return cleaned.length > 0 ? cleaned : [...DEFAULT_AVAILABILITY_DAYS];
};

/** Unión (dedupe + ordenada) de los días permitidos de todos los SVCs del chofer. */
export const getAllowedWeekdaysUnion = (
  svcs: { availabilityDays?: number[] | null }[]
): number[] => {
  const set = new Set<number>();
  for (const s of svcs) {
    for (const d of resolveAvailabilityDays(s.availabilityDays)) set.add(d);
  }
  return [...set].sort((a, b) => a - b);
};

/**
 * Recorre `horizonDays` días de calendario desde `from` (inclusive) y devuelve
 * las fechas (YYYY-MM-DD, local) cuyo weekday está en `union`.
 */
export const getUpcomingAllowedDates = (
  union: number[],
  from: Date,
  horizonDays = 7
): string[] => {
  const out: string[] = [];
  const cur = new Date(from);
  for (let i = 0; i < horizonDays; i++) {
    if (union.includes(cur.getDay())) {
      const y = cur.getFullYear();
      const m = String(cur.getMonth() + 1).padStart(2, "0");
      const d = String(cur.getDate()).padStart(2, "0");
      out.push(`${y}-${m}-${d}`);
    }
    cur.setDate(cur.getDate() + 1);
  }
  return out;
};
